import React, { useCallback, useState } from 'react';
import { EMPTY } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { useService } from '../../../../services/services';
import Spinner from '../../../../components/common/spinner';
import ValidationModalContainer from './validation-modal-container';
import css from '../index.module.css';

interface ValidationStatusProps {
  row: any;
  farmId: string;
  id: string;
  status: string;
  setModal: (modal: React.ReactNode) => void;
}

export default function ValidationStatus({
  row,
  farmId,
  id,
  status,
  setModal,
}: ValidationStatusProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { vaadLizReportV2Service: vaadLizReportService } = useService();

  const getValidationModal = useCallback(() => {
    if (row.ecoscheme_validation_status !== 'NOT_ACCEPTED') {
      return;
    }

    setIsLoading(true);
    vaadLizReportService
      .getValidationInfoForField(farmId, id, row.id_for_validation)
      .pipe(
        tap((validationData: any) => {
          const conditions = [];
          let index = 0;

          validationData.ecoschemeValidations.forEach((validation: any) => {
            validation.conditions.forEach((condition: any) => {
              if (!condition.success) {
                const key = `${validationData.field_nr}-${index}`;
                conditions.push({
                  ...condition,
                  key,
                  code: validation.ecoschemeCode,
                });
                index++;
              }
            });
          });

          setModal(
            <ValidationModalContainer
              conditions={conditions}
              fieldName={row.field_name_value}
              onClose={() => setModal(null)}
            />
          );
        }),
        catchError((error) => {
          console.error('Error fetching validation data', error);
          setIsLoading(false);
          return EMPTY;
        }),
        finalize(() => {
          setIsLoading(false);
        })
      )
      .subscribe();
  }, [farmId, id, row, setModal, vaadLizReportService]);

  return isLoading ? (
    <Spinner visible size="sm" />
  ) : (
    <span
      className={css[row.ecoscheme_validation_status]}
      onClick={getValidationModal}
    >
      {status}
    </span>
  );
}
